import React from 'react';
import { Box, Typography, Skeleton } from '@mui/material';
import { SectionCard, EmptyState } from '../../../../components/ui';
import { brandHome } from '../../brandHomeTokens';
import type { ManagedBrandSummary } from '../../useBrandHomeData';

interface ManagedBrandsCardProps {
  brands: ManagedBrandSummary[];
  loading?: boolean;
}

export const ManagedBrandsCard: React.FC<ManagedBrandsCardProps> = ({ brands, loading }) => {
  return (
    <SectionCard
      dense
      title="Brands you manage pricing for"
      actions={
        brands.length > 0 && (
          <Typography sx={{ fontSize: '12.5px', color: brandHome.color.muted }}>
            {brands.length} brand{brands.length === 1 ? '' : 's'}
          </Typography>
        )
      }
    >
      {loading ? (
        <Box sx={{ p: '15px 20px' }}>
          <Skeleton variant="text" width="60%" />
          <Skeleton variant="rectangular" height={32} sx={{ mt: 1, borderRadius: 1 }} />
        </Box>
      ) : brands.length === 0 ? (
        <EmptyState size="compact" title="No brands found in your submission history yet." />
      ) : (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '7px', p: '13px 20px' }}>
          {brands.map((entry) => (
            <Box
              key={entry.brand}
              component="span"
              sx={{
                height: 28,
                padding: '0 11px',
                border: `1px solid ${brandHome.color.border}`,
                background: brandHome.color.chipFill,
                borderRadius: '14px',
                fontSize: '12.5px',
                color: brandHome.color.bodyAlt,
                lineHeight: '27px',
              }}
            >
              {entry.brand}
              <Box component="span" sx={{ color: brandHome.color.faint, marginLeft: '5px' }}>
                · {entry.fileCount}
              </Box>
            </Box>
          ))}
        </Box>
      )}
    </SectionCard>
  );
};
